import { useClubPropertiesSettingsAsPublic } from "@gymflow/api";
import { ReactNode } from "react";

import { LoadingPortal } from "../../components/pages";
import useGymflowModels from "../../store";
import { ClubSettingsContext } from "./ClubSettingsContext";
import { useCustomColors } from "./useCustomColors";

export function ClubSettingsProvider({
  children,
  enableColorCustomization,
}: {
  children: ReactNode;
  enableColorCustomization?: boolean;
}) {
  const { api } = useGymflowModels();
  const { data: propertiesSettings } = useClubPropertiesSettingsAsPublic({
    api,
  });

  useCustomColors(propertiesSettings?.webSettings, !!enableColorCustomization);
  if (!propertiesSettings) {
    return <LoadingPortal message="Processing club settings ..." />;
  }

  return (
    <ClubSettingsContext.Provider value={propertiesSettings}>
      {children}
    </ClubSettingsContext.Provider>
  );
}
